import React from 'react';
import PropTypes from 'prop-types';
import ServiceView from './ServiceView';
import { SFEntityID, SFService, starfishMediaType, SFNotification } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import { withNotification } from 'common/withNotification';

class ServiceContainer extends React.Component {

  constructor() {
    super();
    this.state = { hasFetched: false };
  }

  componentDidMount() {
    const { id } = this.props;
    const URL = `../api/starfish/success-network/services/${id}`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(service => this.props.onServiceFetched(service))
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    const { service, id, isServiceMember, isStudent, isStaff } = this.props;
    return (
      <ServiceView
        id={id}
        hasFetched={this.state.hasFetched}
        service={service}
        isStudent={isStudent}
        isStaff={isStaff}
        isServiceMember={isServiceMember}
        notification={this.props.notification}
        canSeeStudentServices={this.props.canSeeStudentServices}
        canMakeAppointment={this.props.canMakeAppointment}
        hasConnectLicense={this.props.hasConnectLicense}
      />
    );
  }
}

ServiceContainer.propTypes = {
  id: SFEntityID.isRequired,
  service: SFService,
  onServiceFetched: PropTypes.func.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  notification: SFNotification.isRequired,
  canSeeStudentServices: PropTypes.bool,
  canMakeAppointment: PropTypes.bool,
  hasConnectLicense: PropTypes.bool
};

export default withNotification(ServiceContainer);
